import { FuseChipSelect } from '@fuse';
import _ from '@lodash';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';

class XAPPChipSelect extends XAPPComponent {

    getOptions = () => {
        const { array, select } = this.props;
        var AResponse = [];
        if (!_.isUndefined(array) && !_.isNull(array)) {
            array.forEach(item => {
                AResponse.push({ ...item, value: item.id, label: item.nome });
            });
        }
        return AResponse;
    }

    getSelect = () => {
        const { select } = this.props;
        var AResponse = [];
        if (!_.isUndefined(select) && !_.isNull(select) && select.length > 0) {
            this.getOptions().forEach(item => {
                if (select.includes("{" + item.id + "}")) {
                    AResponse.push({ ...item, value: item.id, label: item.nome });
                }
            });
        }
        return AResponse;
    }

    handleChange = (itens, e) => {
        const { onChange, id } = this.props;
        var ATmp = "";
        if (e.action === 'remove-value') {
            itens.forEach(item => {
                if (ATmp.length > 0) {
                    ATmp = ATmp + ", ";
                }
                ATmp = ATmp + "{" + item.id + "}";
            });
            onChange({ target: { name: id, value: ATmp } });
        }
        else if (e.action === 'select-option') {
            itens.forEach(item => {
                if (ATmp.length > 0) {
                    ATmp = ATmp + ", ";
                }
                ATmp = ATmp + "{" + item.id + "}";
            });
            onChange({ target: { name: id, value: ATmp } });
        }
        else if (e.action === 'clear') {
            onChange({ target: { name: id, value: "" } });
        }
    }

    render() {
        const { label, className, select } = this.props;

        return (
            <FuseChipSelect
                variant="fixed"
                className={className}
                value={this.getSelect()}
                onChange={this.handleChange}
                placeholder=""
                textFieldProps={{
                    className: "",
                    label: label,
                    InputLabelProps: {
                        shrink: true
                    },
                    variant: 'outlined'
                }}
                options={this.getOptions()}
                isMulti
            />
        );
    }
}

export default XAPPChipSelect;
